<header class="header">
    <div class="header-grp">
        <div class="icon" (click)="goBackToPrevPage()">
            <i class="ti ti-chevron-left"></i>
        </div>
        <div class="title">
            <h3>Student Results</h3>
        </div>
        <div class="add-result">
            <a href="/student-results/add-result"><i class="ti ti-plus"></i></a>
        </div>
    </div>
</header>
<main>
    <div class="standard-list">
        <div class="main-members">
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 1</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 2</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 3</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 4</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 5</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 6</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 7</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 8</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 9</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 10</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 11 (Commerce)</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 12 (Commerce)</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 11 (Science)</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Standard 12 (Science)</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>B.Com</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>M.Com</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>B.Sc</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>B.A.</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>B.C.S</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>B.E.</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>B.E.E</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>MSc IT</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
            <a href="/student-results/standard-details" class="member-list-item">
                <div>
                    <h5>Other</h5>
                </div>
                <i class="ti ti-chevron-right"></i>
            </a>
        </div>
    </div>
</main>